module.exports = __webpack_public_path__ + "img/new_index_customers8.e170e365.png";